import { RememberedInformation } from '../models/remembered-information';
import { classMapper } from './class.mapper';

/**
 * Map from model to dto.
 * @param {object} dto DTO data.
 * @returns {RememberedInformation}
 */
function fromDto(dto) {
  return new RememberedInformation({
    rememberClassId: dto.remember_class_id,
    rememberExamLanguageId: dto.remember_exam_language_id,
    rememberClass: dto.remember_class != null ? classMapper.fromDto(dto.remember_class) : null,
  });
}

export const rememberedInformationMapper = {
  fromDto,
};
